import { useState } from "react";
import { Check, Pencil, X } from "lucide-react";
import { toast } from "sonner";
import { errMsg, http } from "../lib/api";

export const TitleEditor = ({ song, onSaved, className = "" }) => {
  const [edit, setEdit] = useState(false);
  const [val, setVal] = useState(song.title);

  const save = async () => {
    const t = val.trim();
    if (!t) return toast.error("Pavadinimas negali būti tuščias");
    if (t === song.title) return setEdit(false);
    try {
      onSaved((await http.patch(`/songs/${song.id}`, { title: t })).data);
      setEdit(false);
      toast.success("Pavadinimas pakeistas");
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!edit) {
    return (
      <div className="flex items-start gap-3 mt-3">
        <h1 data-testid="song-title" className={className}>{song.title || "Kuriama..."}</h1>
        {song.is_mine && song.title && (
          <button data-testid="song-title-edit" onClick={() => { setVal(song.title); setEdit(true); }} title="Keisti pavadinimą"
            className="mt-2 p-2.5 rounded-full border border-[var(--c-line)] text-zinc-400 hover:text-white hover:border-white transition-colors shrink-0">
            <Pencil className="w-4 h-4" />
          </button>
        )}
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2 mt-3">
      <input data-testid="song-title-input-edit" autoFocus value={val} maxLength={80} onChange={(e) => setVal(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEdit(false); }}
        className="flex-1 min-w-0 bg-[var(--c-surface)] border border-[var(--c-orange)] rounded-2xl px-4 py-2 font-display text-2xl sm:text-3xl font-bold focus:outline-none" />
      <button data-testid="song-title-save" onClick={save} className="p-3 rounded-full bg-[var(--c-orange)] text-white hover:bg-[#ff7a26] transition-colors"><Check className="w-5 h-5" /></button>
      <button data-testid="song-title-cancel" onClick={() => setEdit(false)} className="p-3 rounded-full border border-[var(--c-line)] text-zinc-400 hover:text-white transition-colors"><X className="w-5 h-5" /></button>
    </div>
  );
};
